<template lang="pug">
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  @change='$emit("change", $event)'
  item-value='id'
  :items='filterList(filter)'
  :item-text='i => `${i.object_name}`'
  :value='parseValue(value)'
)
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import picker from '@/mixins/picker'

export default {
  mixins: [picker],

  props: {
    label: {
      default: 'Выберите объект'
    }
  },

  created() {
    this.fetch()
  },

  methods: mapActions('dictionary/checklistObjects', ['fetch']),
  computed: mapGetters('dictionary/checklistObjects', ['filterList'])
}
</script>
